const formatMileages = (mileage, conversionUnit, factorRound = false) => {
  if (typeof mileage === 'number') {
      mileage = mileage.toString();
  }

  const unitRoundFactor = conversionUnit === 'milesYards' ? 4 : conversionUnit === 'milesChains' ? 2 : 3;
  let mileageDecimal = conversionUnit === 'milesYards' ? '0000' : conversionUnit === 'milesChains' ? '00' : '000';
  let paddedMileage = '';

  if (mileage !== '') {
      const milageSplit = mileage.split('.');

      if (typeof milageSplit[1] !== 'undefined')
          mileageDecimal = pad(milageSplit[1], unitRoundFactor);

      if (factorRound) {
        switch (unitRoundFactor) {
          case 4:
            mileageDecimal = parseInt(mileageDecimal) > 1759 ? 1759 : mileageDecimal;
            break;
          case 3:
            mileageDecimal = parseInt(mileageDecimal) > 999 ? 999 : mileageDecimal;
            break;
          case 2:
            mileageDecimal = parseInt(mileageDecimal) > 79 ? 79 : mileageDecimal;
            break;
          default:
            break;
        }
      } 

      paddedMileage = milageSplit[0] + '.' + mileageDecimal;
  }


  return paddedMileage;
}

const pad = (str, max) => {
  str = str.toString();
  return str.length < max ? pad(0 + str, max) : str;
};

const isStepChange = (event) => {
  if (!event?.nativeEvent) return false;
  const inputType = event.nativeEvent.inputType;
  return !inputType || inputType === 'insertReplacementText';
};

const inputValue = (event, conversionUnit) => {
  const value = event.target.value;
  if (!value || !isStepChange(event)) return value;

  const unitRoundFactor = conversionUnit === 'milesYards' ? 4 : conversionUnit === 'milesChains' ? 2 : 3;
  const split = value.split('.');
  return formatMileages(`${split[0]}.${(split[1] || '').padEnd(unitRoundFactor, '0')}`, conversionUnit, true);
};

const padNumber = (number, digits) => {
  const parts = number.toString().split(".");
  const integerPart = parts[0].padStart(digits, '0');
  const decimalPart = parts[1] || "0";
  return `${integerPart}.${decimalPart}`;
};

const preciseRound = (number, precision, isNegative) => {
  const factor = Math.pow(10, precision);
  return `${Math.round(number * factor) / factor * (isNegative ? -1 : 1)}`;
};

const convertToMilesYards = (value, currentUnit, isNegative) => {
  const split = value.toString().split(".");
  const major = parseInt(split[0] || 0);
  const minor = parseInt(split[1] || 0);

  if (currentUnit === "milesChains") {
    const majorYards = major * 1760; // convert miles to yards
    const minorYards = minor * 22; // convert chains to yards
    const totalYards = majorYards + minorYards; // calculate total yards
    const miles = Math.floor(totalYards / 1760);
    const remainingYards = totalYards % 1760;
    const remainingPadded = padNumber(remainingYards, 4);
    const paddedSplit = remainingPadded.split(".");

    return preciseRound(`${miles}.${paddedSplit[0]}`, 4, isNegative);
  } else {
    const majorYards = major * 1093.61;
    const minorYards = minor * 1.09361;
    const totalYards = majorYards + minorYards;
    const miles = Math.floor(totalYards / 1760);
    const remainingYards = totalYards % 1760;
    const remainingPadded = padNumber(remainingYards, 4);
    const paddedSplit = remainingPadded.split(".");

    return preciseRound(`${miles}.${paddedSplit[0]}`, 4, isNegative);
  }
};

const convertToMilesChains = (value, currentUnit, isNegative) => {
  const split = value.toString().split(".");
  const major = parseInt(split[0] || 0);
  const minor = parseInt(split[1] || 0);

  if (currentUnit === "milesYards") {
    const majorChains = major * 80;
    const minorChains = minor / 22;
    const totalChains = majorChains + minorChains;
    const miles = Math.floor(totalChains / 80);
    const remainingChains = totalChains % 80;
    const remainingPadded = padNumber(remainingChains, 2);
    const paddedSplit = remainingPadded.split(".");

    return preciseRound(`${miles}.${paddedSplit[0]}`, 2, isNegative);
  } else {
    const majorChains = major * 49.7097;
    const minorChains = minor * 0.0497097;
    const totalChains = majorChains + minorChains;
    const miles = Math.floor(totalChains / 80);
    const remainingChains = totalChains % 80;
    const remainingPadded = padNumber(remainingChains, 2, isNegative);
    const paddedSplit = remainingPadded.split(".");

    return preciseRound(`${miles}.${paddedSplit[0]}`, 2);
  }
};

const convertToKilometersMeters = (value, currentUnit, isNegative) => {
  const split = value.toString().split(".");
  const major = split[0] || 0;
  const minor = split[1] || 0;

  if (currentUnit === "milesYards") {
    const majorMeters = major * 1609.34;
    const minorMeters = minor * 0.9144;
    const totalMeters = majorMeters + minorMeters;
    const kilometers = Math.floor(totalMeters / 1000);
    const remainingMeters = totalMeters % 1000;
    const remainingPadded = padNumber(remainingMeters, 3);
    const paddedSplit = remainingPadded.split(".");

    return preciseRound(`${kilometers}.${paddedSplit[0]}`, 3, isNegative);
  } else {
    const majorMeters = major * 1609.34;
    const minorMeters = minor * 20.1168;
    const totalMeters = majorMeters + minorMeters;
    const kilometers = Math.floor(totalMeters / 1000);
    const remainingMeters = totalMeters % 1000;
    const remainingPadded = padNumber(remainingMeters, 3);
    const paddedSplit = remainingPadded.split(".");

    return preciseRound(`${kilometers}.${paddedSplit[0]}`, 3, isNegative);
  }
};

const convertMileage = (value, currentUnit, targetUnit, isNegative) => {
  if (currentUnit === targetUnit) {
    return value;
  }

  switch(targetUnit) {
    case "milesYards":
      return convertToMilesYards(value, currentUnit, isNegative);
    case "milesChains":
      return convertToMilesChains(value, currentUnit, isNegative);
    case "kilometersMeters":
      return convertToKilometersMeters(value, currentUnit, isNegative);
    default:
      return value;
  }
};

export const Mileage = {
  convertMileage,
  formatMileages,
  inputValue,
  isStepChange,
  padNumber
};
